import system from "@/stores/system";
import { useWindowHeight } from "@react-hook/window-size";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  // 优先从searchParams获取，否则从localStorage获取
  const getInitialRoomId = () => {
    if (process.env.NODE_ENV !== "development") {
      return searchParams.get("room") || localStorage.getItem("roomId") || "";
    } else {
      return "95081902"
      return "30697737"
      return "25640293"; // 我
      return "31097863"; // 爸爸
    }
  };
  const getInitialRoomPwd = () => {
    if (process.env.NODE_ENV !== "development") {
      return searchParams.get("pwd") || localStorage.getItem("roomPwd") || "";
    } else {
      return "17022023"
      return "96402722";
      return "97575353"; // 我
      return "36884894"; // 爸爸
    }
  };
  const [roomId, setRoomId] = React.useState(getInitialRoomId());
  const [roomPwd, setRoomPwd] = React.useState(getInitialRoomPwd());
  const [showPassword, setShowPassword] = React.useState(false);
  const windowHeight = useWindowHeight();

  // 输入变更时保存到本地
  React.useEffect(() => {
    localStorage.setItem("roomId", roomId);
  }, [roomId]);
  React.useEffect(() => {
    localStorage.setItem("roomPwd", roomPwd);
  }, [roomPwd]);

  // 敲门按钮点击
  const handleKnock = async () => {
    if (process.env.NODE_ENV !== "development") {
      if (!roomId) {
        alert("请输入房间号");
        return;
      }
      if (!roomPwd) {
        alert("请输入房间密码");
        return;
      }
      system.playCallAudio();
    }

    navigate(`/call?room=${roomId}&pwd=${roomPwd}`);
  };

  // 通讯录按钮
  const handleContacts = () => {
    navigate("/contacts");
  };
  // 头像按钮
  const handleAvatar = () => {
    navigate("/login");
  };

  return (
    <div
      style={{ height: windowHeight }}
      className="flex portrait:flex-col items-center p-0"
    >
      <img
        className="w-full absolute top-0 left-0 -z-10"
        alt=""
        src={require("@/assets/images/top-shadow.png")}
      />
      <div className="w-full flex flex-col items-center portrait:mt-20">
        <img
          className="w-[10rem] h-[13.25rem]"
          alt="robot"
          src={require("@/assets/images/robot.png")}
        />
        <img
          className="w-[9rem] h-[2.rem]"
          alt=""
          src={require("@/assets/images/famiro.png")}
        />
      </div>

      {/* 顶部栏 */}
      {/* <Row className="justify-between align-items-center px-4 py-3">
        <Col xs="auto">
          <Button
            variant="light"
            onClick={handleContacts}
            className="rounded-circle shadow w-14 h-14"
          >
            <span role="img" aria-label="通讯录">
              📒
            </span>
          </Button>
        </Col>
        <Col xs="auto">
          <Button
            variant="light"
            onClick={handleAvatar}
            className="rounded-circle shadow w-14 h-14"
          >
            <span role="img" aria-label="头像">
              👤
            </span>
          </Button>
        </Col>
      </Row> */}
      {/* <div className="text-center mt-10">
        <span className="fs-5 fw-semibold text-pink-600">{topText}</span>
      </div> */}
      {/* 中间输入区 */}
      <div className="flex flex-col items-center gap-4 portrait:mt-16 w-full px-10 box-border">
        {/* <input className="bg-transparent text-white placeholder-gray-400" /> */}
        <input
          id="roomId"
          className="outline-none border-2 border-solid border-white/35 shadow-none rounded-full w-full bg-transparent text-white px-3 py-2 text-lg"
          type="text"
          placeholder="输入房间号"
          value={roomId}
          onChange={(e) => setRoomId(e.target.value)}
        />
        <div className="px-3 flex items-center w-full border-2 border-solid border-white/30 rounded-full ">
          <input
            id="roomPwd"
            className=" text-white  text-lg w-full bg-transparent border-none outline-none"
            type={showPassword ? "text" : "password"}
            placeholder="输入房间密码"
            value={roomPwd}
            onChange={(e) => setRoomPwd(e.target.value)}
          />
          <div
            className="p-2 bg-transparent active:opacity-40"
            onClick={() => setShowPassword(!showPassword)}
          >
            <img
              alt=""
              className="w-6 h-6"
              src={
                showPassword
                  ? require("@/assets/images/password-hidden.png")
                  : require("@/assets/images/password-show.png")
              }
            />
          </div>
        </div>
        <button
          className="mt-8 w-full bg-black px-5 py-2 rounded-full text-white border-none text-xl"
          onClick={handleKnock}
        >
          敲门
        </button>
      </div>
    </div>
  );
};

export default HomePage;
